module.exports = __webpack_public_path__ + "static/dashboard@2x-a5b2b4e43cbecef70df8e8a69a3dd6e6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/enterprise/dashboard@2x.jpg
// module id = 1090
// module chunks = 168707334958949